// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","exportBtns":"export-buttons_exportBtns__6E8V2","excel":"export-buttons_excel__kZdrS","print":"export-buttons_print__HJCOp"};